import { DataComparator } from '../ListStore';

export function createInverseComparator<D>(comparator: DataComparator<D>): DataComparator<D>
{
    return (d1, d2) =>
    {
        return -1 * comparator(d1, d2);
    };
}
